import isEmpty from 'lodash/isEmpty';
import { toTimeStr } from 'utils/datetime';
import { getTargetChangedValue, getTargetOriginalValue } from '../../../../../../constants/utils';
import { getBasicLogInfo } from './utils';

const preApprovalExpiryDateChangeLogTransformer = (origin) => {
  const oldDate = getTargetOriginalValue(origin, 'preApprovalExpiryDate');
  const newDate = getTargetChangedValue(origin, 'preApprovalExpiryDate');
  let content;
  if (!isEmpty(oldDate) && isEmpty(newDate)) {
    content = 'Pre approval expiry date has been deleted';
  } else if (isEmpty(oldDate) && !isEmpty(newDate)) {
    content = `Pre approval expiry date set to ${toTimeStr(newDate)}`;
  } else {
    content = `Pre approval expiry date changed to ${toTimeStr(newDate)}`;
  }

  return {
    ...getBasicLogInfo(origin),
    content,
  };
};

export default preApprovalExpiryDateChangeLogTransformer;
